export default __webpack_public_path__ + "static/media/ellipse.3a51f98a.webp";